import React from 'react';
import bemClass from '@upsales/components/Utils/bemClass';
import { Flex, Icon, Tooltip } from '@upsales/components';
import './AlertIcon.scss';
import IconName from '@upsales/components/Icon/IconName';
import { useTranslation } from 'Components/Helpers/translate';

const AlertIcon = ({
	icon,
	shouldSync,
	content,
	hideUpdateCompanyData,
	refreshAccount
}: {
	icon: IconName;
	shouldSync: boolean;
	content: string;
	hideUpdateCompanyData: boolean;
	refreshAccount: () => void;
}) => {
	const classes = new bemClass('AlertIcon');
	const { t } = useTranslation();

	if (hideUpdateCompanyData) {
		content = t('account.unlinkToUpdateAgainstProspecting');
	}

	const handleClick = () => {
		if (hideUpdateCompanyData) {
			return;
		}

		refreshAccount();
	};

	return (
		<Tooltip title={content} position="bottom" distance={20} theme="grey-12">
			<Flex
				alignItems="center"
				className={classes.mod({ disabled: hideUpdateCompanyData }).b()}
				onClick={handleClick}
			>
				<Flex
					alignItems="center"
					justifyContent="center"
					className={classes.elem('icon-background').mod({ alert: shouldSync }).b()}
				>
					<Icon name={icon} color="grey-11"></Icon>
				</Flex>
			</Flex>
		</Tooltip>
	);
};

export default AlertIcon;
